import React from "react";
import PropTypes from "prop-types";
import {SwipeablePanelGripBar} from "../../../../components/BaseComponents/SwipeablePanel/SwipeablePanelGripBar";
import {SwipeablePanel} from "../../../../components/BaseComponents/SwipeablePanel/SwipeablePanel";
import {SwipeablePanelBackdrop} from "../../../../components/BaseComponents/SwipeablePanel/SwipeablePanelBackdrop";
import BookingAPI from "../../../../api/BookingAPI";
import {swal, swalLoading} from "../../../../helpers/SweetAlertWrapper";
import {CheckboxSwitch} from "../../../../components/Bootstrap4/CustomControl/CheckboxSwitch";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";

export class ServiceBookResumeServiceSelectorPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            services: null,
            selectedServiceIds: [...this.props.bookServiceIds]
        }
        this.scrollableContainerRef = null;
        this.scrollableContainerStyle = {
            maxHeight: '80vh',
        }
    }

    componentDidMount() {
        swalLoading('Attendere prego...');
        BookingAPI.getRichData(this.props.idNegozio)
            .then(bookingData => {
                this.setState({
                    services: bookingData.servizi
                });
                swal.safeClose();
            });
    }

    isSwipeDisabled = _ => {
        if (this.scrollableContainerRef) {
            return this.scrollableContainerRef.scrollTop > 0;
        }
        return false;
    }

    handleScrollableContainerRef = ref => {
        this.scrollableContainerRef = ref;
    }

    handleServiceCheckboxChange = event => {
        const ids = [...this.state.selectedServiceIds];
        if (event.target.checked) {
            ids.push(event.target.value);
        }else{
            ids.splice(ids.indexOf(event.target.value), 1);
        }
        this.setState({selectedServiceIds: ids})
    }

    handleConfirm = _ => {
        this.props.onConfirm(this.state.selectedServiceIds);
    }

    render() {
        if (!this.state.services) return '';
        return (
            <React.Fragment>
                <SwipeablePanelBackdrop onClick={this.props.onDismiss}/>
                <SwipeablePanel
                    swipeTreshold={5}
                    direction={'top-to-bottom'}
                    active={true}
                    onDismiss={this.props.onDismiss}
                    disableSwipe={this.isSwipeDisabled}
                    animationSpeed={150}
                >
                    <SwipeablePanelGripBar className={"bg-main-z2 rounded-top"}/>
                    <div className={"bg-main-z2 p-3"} style={this.scrollableContainerStyle} ref={this.handleScrollableContainerRef}>
                        <h4 className={"font-weight-bold"}>Modifica data e ora</h4>
                        <p>Puoi deselezionare dei servizi che non desideri più effettuare</p>
                        <div className={"list-group"}>
                            {
                                this.props.bookServiceIds.map(id => {
                                    const service = this.state.services.find(s => s.id_servizio == id);
                                    if (!service) return '';
                                    return <div className={"list-group-item"} key={id}>
                                        <CheckboxSwitch
                                            label={service.nome}
                                            checked={this.state.selectedServiceIds.includes(id)}
                                            onChange={this.handleServiceCheckboxChange}
                                            value={id}
                                        />
                                    </div>
                                })
                            }
                        </div>
                        <div className={"text-center mt-3"}>
                            {
                                this.state.selectedServiceIds.length <= 0 &&
                                <p className={"text-danger"}>
                                    <FaSolidIcon name={"exclamation-triangle"}/> Seleziona almeno un servizio per procedere
                                </p>
                            }
                            <button className={"btn btn-primary btn-block"} onClick={this.handleConfirm} disabled={this.state.selectedServiceIds.length <= 0}>
                                Scegli nuova data e ora <FaSolidIcon name={"chevron-right"}/>
                            </button>
                        </div>
                    </div>
                </SwipeablePanel>

            </React.Fragment>
        )
    }

}

ServiceBookResumeServiceSelectorPanel.propTypes = {
    idNegozio: PropTypes.any.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
    bookServiceIds: PropTypes.arrayOf(PropTypes.any),
}
